import React , { useState, useEffect } from 'react';
import { setDislikePostApi, setLikePostApi } from '../../../../api/comment';
import { getPostApi } from '../../../../api/post';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { errorModal, successModal, warningModal, infoModal } from '../../../Alerts/Alerts';
import Like from '../../../../assets/images/like.svg';
import Dislike from '../../../../assets/images/dislike.svg';
import { Form } from 'react-bootstrap';
import ReactGA from 'react-ga';

export default function InfoSearch(props) {
    const { url } = props;
    const [ postInfo, setPostInfo ] = useState(null);
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        getPostApi(url)
        .then(response => {
            if (response.code !== 200) {
               warningModal("Advertencia", response.message);
            } else {
            setPostInfo(response.posts);
            }
        })
        .catch(() => {
            errorModal	("Error", "Error del Servidor.");
        });
        
    }, [url]);

    if (!postInfo) {
        return (
            <Spinner animation="border" role="status" ></Spinner>
        );
    }

    ReactGA.set({post:postInfo[0].nm_titulo});

    return (
            <>
                <ShowDetailPost 
                    postInfo={postInfo} 
                />

                <ShowCommentPost 
                    postInfo={postInfo} 
                    disabled={disabled} 
                    setDisabled={setDisabled} 
                />
            </>
    )
}

function ShowDetailPost(props) {
    const { postInfo } = props;

    return(
        <>
            <div className="row">
                <div className="col-md-12 col-xl-12 py-md-3 pl-md-1 bd-content">
                    <div className="containerImg mb-3 mr-4 ml-4 mt-2" dangerouslySetInnerHTML={{__html: postInfo[0].gl_contenido}}></div>
                </div>
            </div>
        </>
    )
}

function ShowCommentPost(props) {
    const { postInfo, disabled, setDisabled } = props;
    const [ comment, setComment ] = useState('');
    const [ charCount, setCharCount ] = useState(0);

    const handleClickLike = (e) => {
        e.preventDefault();
        if(postInfo[0] && postInfo[0]._id){
            let page = '';
            page = localStorage.getItem('page');
            let vote = 1;
            if(page){
                vote = page.indexOf(postInfo[0].url);
                switch (vote) {
                    case -1:
                        setLikePostApi(postInfo[0]._id).then(result => {
                            if(result.code ===200){
                                successModal('Vote Sent', 'Thank you for your feedback.');
                                localStorage.setItem('page', page+','+postInfo[0].url);
                                setDisabled(true);
                            }
                        })
                        break;
                    default:
                        infoModal('Vote Information', 'You already voted this publication');
                        break;
                }
            }else{
                setLikePostApi(postInfo[0]._id).then(result => {
                    if(result.code ===200){
                        successModal('Vote Sent', 'Thank you for your feedback.');
                        localStorage.setItem('page', [postInfo[0].url]);
                        setDisabled(true);
                    }
                })
            }
        }
        
    }

    const handleClickDislike = (e) => {
        e.preventDefault();
        if(!disabled){
            warningModal('Warning', 'You must enter a comment and click Send.');
        }else{
            setDisabled(false);
        }
    }

    const wordCount = (chars) => {
        var currentText = chars;
        var characterCount = currentText.length;
        setCharCount(1000 - characterCount);
    }

    const handleChangeComment = (e) => {
        e.preventDefault();
        setComment({ ...comment, comment: e.target.value});
        wordCount(e.target.value);
    }

    const handleClickSend = (e) => {
        e.preventDefault();
        let aux_comment = comment;
        if(aux_comment.comment){
            aux_comment.comment = transformTextNoSpChar(aux_comment.comment);
        }
        if(aux_comment.length ===0 || aux_comment.comment === ''){
            warningModal('Warning', 'You must enter a comment before sending your vote.');
        }else{
            let page = '';
            page = localStorage.getItem('page');
            let vote = 1;
            if(page){
                vote = page.indexOf(postInfo[0].url);
                switch (vote) {
                    case -1:
                        setDislikePostApi(postInfo[0]._id, aux_comment).then(result => {
                            if(result.code ===200){
                                successModal('Vote Sent', 'Thank you for your feedback.');
                                setComment('');
                                localStorage.setItem('page', page+','+postInfo[0].url);
                                setDisabled(true);
                            }
                        })
                        break;
                    default:
                        infoModal('Vote Information', 'You already voted this publication');
                        setComment('');
                        setDisabled(true);
                        break;
                }
            }else{
                setDislikePostApi(postInfo[0]._id, aux_comment).then(result => {
                    if(result.code ===200){
                        successModal('Vote Sent', 'Thank you for your feedback.');
                        setComment('');
                        setDisabled(true);
                        localStorage.setItem('page', [postInfo[0].url]);
                    }
                })
            }
        }
    }

    return(
        <>
            <div className="row">
                <div className="col-6">
                    <div className="filter-tag-container">
                        <label><strong>Category: </strong>
                            {postInfo[0] && postInfo[0].id_categoria && postInfo[0].id_categoria.nm_categoria ? (
                                <span>
                                    {postInfo[0].id_categoria.nm_categoria}
                                </span>
                            ) : (
                                ''
                            )}
                        </label>
                    </div>
                </div>
                <div className="col-6 text-right">
                    <div className="row">
                        <div className="col-12 text-right">
                            <Link 
                                to={""} 
                                onClick={handleClickLike}
                            >
                                <img className="likes" src={Like} alt="" />
                            </Link>
                            <Link 
                                to={""} 
                                onClick={handleClickDislike}
                            >
                                <img className="likes" src={Dislike} alt="" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <div>
                {!disabled ? (
                    <>
                        <div className="row">
                            <div className="col-12">
                                <Form>
                                    <Form.Group controlId="exampleForm.ControlTextarea1">
                                        <Form.Control 
                                            disabled={disabled}
                                            as="textarea" 
                                            rows="3"
                                            maxLength="1000"
                                            onChange={handleChangeComment}
                                        />
                                    </Form.Group>
                                    <p>Max. Chars: 1000. Chars Left: {charCount}</p>
                                </Form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 text-right">
                            <button 
                                className={disabled ? 'btn btn-success disabled' : 'btn btn-success'}
                                onClick={handleClickSend}
                            >Send</button>
                            </div>
                        </div>
                    </>
                ) : ('')}
            </div>
            <br/>
        </>
    )
}

function transformTextNoSpChar(text) {
    const txt = text
                  .replace(/[ÁÀÄ]/g,"A")
                  .replace(/[áàä]/g,"a")
                  .replace(/[ÉÈË]/g,"E")
                  .replace(/[éèë]/g,"e")
                  .replace(/[ÍÌÏ]/g,"I")
                  .replace(/[íìï]/g,"i")
                  .replace(/[ÓÒÖ]/g,"O")
                  .replace(/[óòö]/g,"o")
                  .replace(/[ÚÙÜ]/g,"U")
                  .replace(/[úùü]/g,"u")
                  .replace(/[Ç]/g,"C")
                  .replace(/[ç]/g,"c")
                  .replace(/[Ñ]/g,"N")
                  .replace(/[ñ]/g,"n")
                  .replace(/[^a-zA-Z0-9 .:&]/g, '');
    return txt;
  }